const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchMgref ({ state, commit, rootState }, params) {
    return rootState.axios.get('/opensearch/v1frontend/user/search-mgref', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
